import { RootState } from '../core';

export const authTokenSelector = (state: RootState) => state.user.authToken;

export const refreshTokenSelector = (state: RootState) =>
  state.user.refreshToken;

export const isEmailConfirmedSelector = (state: RootState) =>
  state.user.isEmailConfirmed;
